import { Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import Paper from 'components/Paper'

export const NotPurchasedSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/layout')

  return (
    <Paper>
      <FlexBox
        axis='xy'
        sx={{
          color: (theme: Theme): string => theme.palette.grey[600],
          p: 3,
        }}
      >
        {t('section.notPurchased')}
      </FlexBox>
    </Paper>
  )
}
